import { initializeI18n } from '@inbody/core';

/*
  화면 문구는 한국어로 박혀 있어 앱 리소스는 없다. 초기화하는 이유는 공용 부품(@inbody/ui 날짜 선택기 등)이
  useTranslation('ui') 을 쓰기 때문 — 초기화가 없으면 t() 가 키를 그대로 돌려줘서
  '{{year}}년 {{month}}월' 같은 치환 문구가 그대로 보인다. 패키지 문구는 패키지가 스스로 등록한다.

  한국어 전용 앱(헤더 언어 전환 숨김)이라 감지기를 끄고 기본값(ko)으로 고정한다.
*/
initializeI18n({ detection: { order: [], caches: [] } });
